import {getGrades,getBranchSchools} from '@/api/setting'
import { getRoles } from "@/api/users";
import {setFirstLetterUpperCase} from "@/utils/is-rules"
const user = {
    state: {
      adminUserInfo: null,
      grades: [],
      roles: [],
      branchSchools: [],
    },
    mutations: {
      SET_adminUserInfo(state, adminUserInfo) {
        state.adminUserInfo = adminUserInfo
      },
      SET_roles(state, roles){
        state.roles = roles
      },
      SET_Grades(state,grades){
        state.grades = grades
      },
      SET_BranchSchool(state,branchSchools){
        state.branchSchools = branchSchools
      },
    },
    actions: {
      // 获取用户信息
      setAdminUserInfo({ commit },adminUserInfo) {
        commit('SET_adminUserInfo',adminUserInfo)
      },
      // 获取角色
      getRoles({ commit }) {
        new Promise(resolve => {
          getRoles().then(res => {
           commit('SET_roles', setFirstLetterUpperCase(res.data))
           resolve(res.data)
         })
       })
     },
      getGrades({ commit }) {
        new Promise(resolve => {
          getGrades().then(res => {
           commit('SET_Grades', res.data)
           resolve(res.data)
         })
       })
     },
     getBranchSchools({ commit }) {
        new Promise(resolve => {
          getBranchSchools().then(res => {
           commit('SET_BranchSchool', res.data)
           resolve(res.data)
         })
       })
     },
    }
}

export default user